import { useAppConnectionCardModel } from './useAppConnectionCardModel'
import { AppConnectionCardErrorView } from './AppConnectionCardErrorView'
import { AppConnectionCardBlockMain } from './AppConnectionCardBlockMain'

export default function AppConnectionCardBlockView({
  title,
  description = '',
  iconUrl = null,
  status = 'connected',
  tags = [],
  successBullets,
  successClosing,
  toolkitSlug = null,
}) {
  const model = useAppConnectionCardModel({ title, status, toolkitSlug, successBullets, successClosing })

  if (status === 'error') {
    return (
      <AppConnectionCardErrorView
        safeTitle={model.safeTitle}
        description={description}
        statusLabel={model.statusLabel}
        chipColor={model.chipColor}
      />
    )
  }

  return (
    <AppConnectionCardBlockMain
      model={model}
      description={description}
      iconUrl={iconUrl}
      status={status}
      tags={tags}
    />
  )
}
